export const fontWeightRegular = 400;
export const fontWeightMedium = 500;
export const fontWeightBold = 700;
